import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    institucion: {
      institution: {
        name: '',
        description: '',
        institution_type_id: 1,
        id: null,
        branch_offices: []
      },
      settings: {
        allow_quotation: 0,
        allow_public_quotation: 0,
        allow_scheduling: 0,
        allow_public_scheduling: 0,
        notification_email: ''
      }
    },
    branchOfficeSelected: null,
    branchOfficeSelectedIndex: null,
    roles: [
      {text: 'Gerente', id: 0},
      {text: 'Administrativo', id: 1},
      {text: 'Especialista', id: 2}
    ]
  }
}

export default {
  namespaced: true,
  state: {
    institucion: {
      institution: {
        name: '',
        description: '',
        institution_type_id: 1,
        id: null,
        branch_offices: []
      },
      settings: {
        allow_quotation: 0,
        allow_public_quotation: 0,
        allow_scheduling: 0,
        allow_public_scheduling: 0,
        notification_email: ''
      }
    },
    branchOfficeSelected: null,
    branchOfficeSelectedIndex: null,
    roles: [
      {text: 'Gerente', id: 0},
      {text: 'Administrativo', id: 1},
      {text: 'Especialista', id: 2}
    ]
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setBranchOffices(state, payload) {
      state.institucion.institution.branch_offices = payload
    },
    loadInstitutionData(state, payload) {
      const data = state.institucion
      data.institution.name = payload.name
      data.institution.description = payload.description
      data.institution.id = payload.id
    },
    setBranchOfficeById(state, payload) {
      state.institucion.institution.branch_offices[payload.index] = payload.office
    },
    addBranchOffice(state, payload) {
      state.institucion.institution.branch_offices.push(payload)
      const offices = state.institucion.institution.branch_offices
      if (payload.main && offices.length > 1) {
        const index = offices.findIndex(sel => sel.name === payload.name)
        offices.forEach((item, i) => {
          if (i !== index) {
            item.main = 0
          } else {
            item.main = 1
          }
        })
      }
    },
    setInstitutionData(state, payload) {
      state.institucion.institution.name = payload.name
      state.institucion.institution.description = payload.description
    },
    selectBranchOffice(state, payload) {
      state.branchOfficeSelected = payload.item
      state.branchOfficeSelectedIndex = payload.index
    },
    addUserToBranch(state, payload) {
      const office = state.institucion.institution.branch_offices[state.branchOfficeSelectedIndex]
      office.users.unshift(payload)
    }
  },
  actions: {
    addUserToBranch(ctx, payload) {
      if (checkEmailExists(payload.email, ctx.state.branchOfficeSelected)) {
        return false
      } else {
        ctx.commit('addUserToBranch', payload)
        return true
      }
    },
    setBranchOfficeById(ctx, payload) {


      if (!payload.id)
        return false
      const offices = ctx.state.institucion.institution.branch_offices
      const index = offices.findIndex(sel => sel.id === payload.id)
      if (index === -1 )
        return false
      ctx.commit('setBranchOfficeById', {index, office: payload})
      ctx.dispatch('sendBranchOfficesToApi')
      return {ok: true}
    },
    async sendBranchOfficesToApi(ctx) {

      const {id} = ctx.rootState.currentProvider
      const inst = ctx.state.institucion.institution
      const institution = {
        id: inst.id,
        branches_offices: inst.branches_offices
      }
      const response = await ApiUtils.makePatch('provider', id, institution)
      const decoded = await response.json()

    }
  },
  getters: {
    institucion: (state) => state.institucion,
    selected: (state) => state.branchOfficeSelected,
    roles: (state) => state.roles
  }
}

function checkEmailExists(mail, sucursal) {
  let existe = false
  if (sucursal.users.length > 0) {
    sucursal.users.forEach(user => {
      if (user.email === mail) {
        existe = true
      }
    })
  }
  return existe
}
